import React, { FC } from 'react'
import { cn } from 'shared/utils'

import styles from './Unauthorized.module.scss'
import { ErrorPageContent } from 'components/ErrorPageContent/ErrorPageContent'
import { ClientError } from 'modules/Errors/components'
import { Button } from '@wmgtech/legato'
import { useNavigate } from 'react-router-dom'

type TUnauthorizedProps = {
  title?: string
  description?: string
  className?: string
  showActionButtons?: boolean
  children?: React.ReactNode
}

export const Unauthorized: FC<TUnauthorizedProps> = (props) => {
  const {
    title = 'Access denied',
    description = 'Ooops... Seems that you do not have rights to get this page',
    showActionButtons = true,
    className
  } = props
  const navigate = useNavigate()
  return (
    <div className={cn(className)}>
      <ErrorPageContent
        title={title}
        description={description}
        children={<ClientError />}
      />
      {props.children}
      {showActionButtons && (
        <div className={styles.buttonContainer}>
          <Button size="lg" onClick={() => navigate(-1)}>Go back</Button>
          <Button size="lg" onClick={() => navigate('/')}>Go to homepage</Button>
        </div>
      )}
    </div>
  )
}


